'use strict';

var novicell = novicell || {};
novicell.searchResults = novicell.searchResults || function () {
    function init() {
        var searchField = document.querySelector('.search-field__search-field');
        if(searchField != null){
            searchField.focus();
        }
    }

    return {
        init:init
    };
}();
//to be able to use it as a callback
function focusOnSearchInput(){
    novicell.searchResults.init();
}